import { REPORTSUMMARYGRAPHS_SUCCESS, REPORTSUMMARYGRAPHS_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const reportSummaryGraphsReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORTSUMMARYGRAPHS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REPORTSUMMARYGRAPHS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default reportSummaryGraphsReducer;
